








import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../mixins";
import DatePicker from "./DatePicker.vue";

@Component({
  components: {
    DatePicker,
  }
})
export default class DateDurationPicker extends Mixins(ModelEditableMixin) {
  get from(): Date {
    return this.editingSource.from;
  }

  set from(source: Date) {
    this.writeProperty(s => s.from = source);
  }

  get to(): Date {
    return this.editingSource.to;
  }

  set to(source: Date) {
    this.writeProperty(s => s.to = source);
  }

  get isInverted(): boolean {
    return (!!this.to && !!this.from && (this.from > this.to));
  }
}
